import Query from '../../core/query/query';
export class QuotingQuery extends Query {

}